import React from "react"
import "./OverlayLoader.css"

const OverlayLoader = ({ isLoading, message = "Loading...", fullScreen = true }) => {
  if (!isLoading) return null

  return (
    <div className={`overlay-loader ${fullScreen ? "fullscreen" : ""}`}>
      <div className="overlay-content">
        <div className="dot-loader">
          <span />
          <span />
          <span />
        </div>
        {message && <div className="overlay-message">{message}</div>}
      </div>
    </div>
  )
}

export default OverlayLoader